export type SupportedLanguage = 'th' | 'zh' | 'mx' | 'en' | 'ms';

const supportedLanguages: SupportedLanguage[] = ['th', 'zh', 'mx', 'en', 'ms'];

interface CustomParam {
  licenseNumber?: unknown;
  language?: unknown;
}

export const parseCustomParam = (config: any): CustomParam => {
  if (typeof config?.customParam !== 'string' || !config.customParam.trim()) return {};
  try {
    const value = JSON.parse(config.customParam);
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  } catch {
    return {};
  }
};

export const getLicenseNumber = (config: any): string => {
  const value = parseCustomParam(config).licenseNumber;
  return typeof value === 'string' && value.trim() ? value.trim() : '-';
};

export const getConfiguredLanguage = (config: any): SupportedLanguage => {
  const customLanguage = parseCustomParam(config).language;
  if (supportedLanguages.includes(customLanguage as SupportedLanguage)) {
    return customLanguage as SupportedLanguage;
  }

  if (supportedLanguages.includes(config?.language as SupportedLanguage)) {
    return config.language as SupportedLanguage;
  }

  return 'th';
};

export const applyTemplateBranding = (config: any, targetDocument: Document = document): void => {
  const templateId = Number(config?.templeteId);
  if (templateId < 17 || templateId > 21) return;

  if (typeof config?.company === 'string' && config.company.trim()) {
    targetDocument.title = config.company.trim();
  }

  if (typeof config?.logoPrc !== 'string' || !config.logoPrc.trim()) return;

  let favicon = targetDocument.querySelector<HTMLLinkElement>('link[rel~="icon"]');
  if (!favicon) {
    favicon = targetDocument.createElement('link');
    favicon.rel = 'icon';
    targetDocument.head.appendChild(favicon);
  }
  favicon.type = 'image/png';
  favicon.href = config.logoPrc.trim();
};
